import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import { LtlCustomer } from "./types";
import {
  addUpdateCustomerFailure,
  addUpdateCustomerSuccess,
  fetchLTLCustomerListFailure,
  fetchLTLCustomerListSuccess,
} from "./actions";
import {
  ADD_UPDATE_CUSTOMER_REQUEST,
  FETCH_LTL_CUSTOMER_LIST_REQUEST,
} from "./actionTypes";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchLtlCustomerListSaga(action: any) {
  try {
    const response: LtlCustomer[] = yield call(
      postRequest,
      action.url,
      action.payload
    );
    const totalCount = response.length > 0 ? response[0].totalCount : 0;
    yield put(fetchLTLCustomerListSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchLTLCustomerListFailure(errorMessage));
  }
}

function* addUpdateCustomerSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload
    );
    yield put(addUpdateCustomerSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdateCustomerFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* ltlCustomerSaga() {
  yield takeLatest(FETCH_LTL_CUSTOMER_LIST_REQUEST, fetchLtlCustomerListSaga);
  yield takeLatest(ADD_UPDATE_CUSTOMER_REQUEST, addUpdateCustomerSaga);
}
